export default __webpack_public_path__ + "static/media/manish.3ac11cf6.png";